import React from 'react';
import {
    Box,
    Button,
    Container,
    Divider,
    Link,
    Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import ScrollToTopButton from "./ScrollToTopButton";

export default function Terms() {
    return (
    <Box >
        <ScrollToTopButton />
        <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                bgcolor: '#223f73' }}>
            <Box
            component="img"
            src="/images/logo.png"
            alt="Logo"
            sx={{
                maxWidth: '160px',
                height: 'auto',
                display: 'block',
            }}
            />
            <Button component={NavLink} to='/' sx={{color: 'white', mr: 2}}>
                Home
            </Button>
        </Box>
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                Email Terms and Conditions
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Effective Date: April 1, 2025
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Last Revised: April 19, 2025
            </Typography >

            <Box mt={4}>
            <Typography variant="h6">1. Purpose</Typography>
            <Typography paragraph>
            These Email Terms govern all email messages sent by PR Innova Inc. and its brands to subscribers, customers, or prospects.
            </Typography>
    
            <Typography variant="h6">2. Types of Email</Typography>
            <Box sx={{ p: 2 }}>
                <Box
                    sx={{
                    display: "flex",
                    mb: 1,
                    // this ensures the two columns are spaced exactly by their flex values
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Category
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
                    Examples
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
                    Opt-Out?
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Transactional
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Receipts, account notices, password resets	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Essential; cannot be disabled while you hold an account
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Service Notices	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Downtime alerts, feature changes, policy updates	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Essential
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Promotional / Marketing	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Newsletters, special offers, surveys		
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Yes – unsubscribe at any time
                    </Typography>                    
                </Box>

            </Box>
    
            <Typography variant="h6">3. Consent</Typography>
            <Typography paragraph>
            We send marketing emails only to (i) individuals who explicitly opt in (checkbox, webform, double opt-in link) or (ii) existing customers under “soft opt-in” rules, where permitted by law.
            </Typography>
    
            <Typography variant="h6">4. Sender Identification</Typography>
            <Typography paragraph>
            Each email clearly states: (a) the sender is PR Innova Inc. or a specific brand, (b) our postal address, and (c) a valid reply-to email.
            </Typography>
    
            <Typography variant="h6">5. Unsubscribe Mechanism</Typography>
            <Typography paragraph>
            Every marketing email includes a one-click unsubscribe link. Requests are honored within 10 business days, as required by the CAN-SPAM Act.
            </Typography>

            <Typography variant="h6">6. Forward-To-Friend</Typography>
            <Typography paragraph>
            If we provide a “forward” feature, you must ensure you have the recipient’s consent.
            </Typography>

            <Typography variant="h6">7. Data Privacy</Typography>
            <Typography paragraph>
            Subscriber emails are handled in accordance with the {' '}<Link component={NavLink} to='/privacy'>Privacy Policy</Link>{' '} and are not sold or disclosed to third parties for their own marketing.
            </Typography>

            <Typography variant="h6">8. User Responsibilities</Typography>
            <Typography paragraph>
            You must not abuse any referral or promotional codes, and you must not mark our legitimate emails as spam if you have consented to receive them.
            </Typography>

            <Typography variant="h6">9. Disclaimers & Limitation of Liability</Typography>
            <Typography paragraph>
            Emails may contain forward-looking statements or links to third-party resources. We are not responsible for external content. Our liability is limited as stated in the Terms of Use.
            </Typography>

            <Typography variant="h6">10. Changes</Typography>
            <Typography paragraph>
            We may modify these Email Terms. Updated versions will be posted on our website with a new effective date.
            </Typography>

            <Typography variant="h6">11. Contact Us</Typography>
            <Typography paragraph>
                If you have any questions about these Email Terms, please contact us at:
                <br /><br />
                <strong>PR Innova Inc</strong>
                <br />
                127 Calle Guadalquivir
                <br />
                San Juan PR 00927
                <br />
                <Link href="mailto:support@prinnovainc.com">support@prinnovainc.com</Link>
                <br />
            </Typography>
            </Box>
        </Container>
    </Box>
    )
}
